<template>
  <v-dialog v-model="value" max-width="400" :dark="dark">
    <v-card :color="color">
      <v-card-title />
      <v-card-text class="text-subtitle-1 ">
        {{ $dictionary.get('out-of-menu-time-text') }}
        {{ $tools.time.range(menuData.time_limit_range[0], menuData.time_limit_range[1]) }}
      </v-card-text>
      <v-card-text>
        <Button title="close" sub-button @click="close" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from '@/components/dialogs/DialogMixin';
import Button from '@/components/Button';

export default {
  name: 'OutOfMenuTime',
  components: { Button },
  mixins: [DialogMixin],
  props: {
    menu: { type: String, default: null }
  },
  computed: {
    menuData() {
      const { points, point } = this.$store.state.data;
      return points[point].catalogues.find(({ _id }) => _id === this.menu);
    },
  }
};
</script>
